import { DataBean } from "../DataBean";

export class Message extends DataBean {

    public async sendOTPAccountByNit(nit: number): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.message.bean.Message_sendOTPAccountByNit_Number", [nit]);
    }

    public async sendOTPAccount(idAccount: number): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.message.bean.Message_sendOTPAccount_Number", [idAccount]);
    }

    public async validateOTPAccount(idAccount: number, otpCode: string): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.message.bean.Message_validateOTPAccount_Number_String", [idAccount, otpCode]);
    }
    
    public async getMessageCatalogRender(page:number,rows:number,data:any): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.shared.Report_getMessageCatalogRender_Number_Number_java.util.Map", [page,rows,data]);
    }


}